import React from "react";

import { useGetCarbonProgramByFarmId, useNavigate, useTranslation, useUserContext } from "utils";

import { ACCOUNTING_METHODOLOGY } from "models";

import { Button, Flex, Icon, OutlinedCard, Tag } from "components";

export const HomePagePlanningList = () => {
  const { t } = useTranslation("dashboard");
  const navigate = useNavigate();
  const { user } = useUserContext();

  const { data: carbonProgram } = useGetCarbonProgramByFarmId(user?.farm?.id ?? undefined);

  const fields = user?.farm?.fields ?? 0;

  const hideSimulation = !user?.farm || fields < 1 || !carbonProgram?.isEnabled || carbonProgram.accountingMethodology !== ACCOUNTING_METHODOLOGY.intervention;

  return (
    <Flex className="homepage-planning-card" vertical={false} gap="1rem" flex={1}>
      {hideSimulation ? null : (
        <OutlinedCard dataTestId="home-planning-card" className="card-item">
          <div className="icon-wrapper">
            <Icon iconName="klim/graph" size="xl" />
          </div>
          <h2 className="margin-bottom-400">{t("planningCard.simulation.title")}</h2>
          <Button type="primary" size="small" style={{ width: "fit-content" }} onClick={() => navigate("/all-fields/simulations")}>
            {t("planningCard.simulation.button")}
          </Button>
        </OutlinedCard>
      )}
      <OutlinedCard dataTestId="home-farm-card" className="card-item">
        <div className="icon-wrapper">
          <Icon iconName="klim/plant-ai" size="xl" />
        </div>
        <Flex align="center" className="margin-bottom-400">
          <h2>{t("planningCard.coverCropMix.title")}</h2>
          <Tag className="margin-left-50" colour="yellow" text={t("planningCard.new")} />
        </Flex>
        <Button type="primary" size="small" style={{ width: "fit-content" }} onClick={() => navigate("/cmc")}>
          {t("planningCard.coverCropMix.button")}
        </Button>
      </OutlinedCard>
    </Flex>
  );
};
